import { gql } from "apollo-boost";

export const CONSULTORY_PARAMETERS = gql`
  query consultoryParameters(
    $where: ConsultoryParametersInput
    $relations: [String]
  ) {
    consultoryParameters(where: $where, relations: $relations) {
      id
      amountConfiguration
      medicalParameterGroup {
        id
        name
      }
      specialty {
        id
        name
      }
      consultoryParametersDetail {
        id
        enabled
        frequency {
          id
          name
        }
        medicalParameters {
          id
          name
          fillInAppointment
          min
          max
          minAge
          maxAge
          value
          unitOfMeasurement
          genderId
          typeId
          frequencyId
          enabled
          gender {
            id
            name
          }
          type {
            id
            name
          }
          frequency {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_SPECIALITIES_BY_MEDICAL = gql`
  query specialitiesByMedical(
    $where: SpecialitiesByMedicalInput
    $relations: [String]
  ) {
    specialitiesByMedical(where: $where, relations: $relations) {
      id
      speciality {
        id
        name
        specialtiesMedicalParametersGroup {
          id
          medicalParameterGroup {
            id
            name
            enabled
            parameters {
              id
              medicalParameter {
                id
                name
                fillInAppointment
                min
                max
                minAge
                maxAge
                value
                unitOfMeasurement
                genderId
                typeId
                frequencyId
                enabled
                gender {
                  id
                  name
                }
                type {
                  id
                  name
                }
                frequency {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const MEDICAL_PARAMETERS_TO_GROUPS = gql`
  query medicalParametersToGroups(
    $where: medicalParametersToGroupsInput
    $relations: [String]
  ) {
    medicalParametersToGroups(where: $where, relations: $relations) {
      medicalParameter {
        id
        name
        fillInAppointment
        min
        max
        minAge
        maxAge
        value
        unitOfMeasurement
        genderId
        typeId
        frequencyId
        enabled
        gender {
          id
          name
        }
        type {
          id
          name
        }
        frequency {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_OR_UPDATE_PARAMETERS = gql`
  mutation createOrUpdateConsultoryParameters(
    $data: [CreateOrUpdateConsultoryParametersInput]
  ) {
    createOrUpdateConsultoryParameters(data: $data)
  }
`;

export const GET_FREQUENCIES = gql`
  query frequencies($where: frequenciesInput) {
    frequencies(where: $where) {
      id
      name
    }
  }
`;
